import React from 'react';
import { Anchor, Grid } from '@mantine/core';
import PropTypes from 'prop-types';
import AppStack from '../../common/AppStack';
import AppText from '../../common/AppText';
import AppFlexbox from '../../common/AppFlexbox';
import CreationWizardButton from './CreationWizardButton';

const StoreCreationStoreTypeStep = ({
  loading,
  createOptions,
  formState,
  setFormState
}) => {
  const { storeType } = formState;

  return (
    <AppStack style={{ gap: 20, paddingTop: 10 }}>
      <Grid>
        <Grid.Col span={6}>
          <CreationWizardButton
            label="Personal store"
            onClick={() => {
              setFormState({ ...formState, storeType: 'personal' });
            }}
            selected={storeType === 'personal'}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <CreationWizardButton
            label="Team store"
            onClick={() => {
              setFormState({ ...formState, storeType: 'team' });
            }}
            selected={storeType === 'team'}
          />
        </Grid.Col>
      </Grid>

      {storeType === 'personal' && (
        <AppStack
          style={{
            gap: 0,
            marginTop: 10,
            flex: 1,
            padding: '0px 40px',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <AppText
            style={{
              fontSize: 14,
              color: '#666',
              fontStyle: 'italic',
              textAlign: 'center'
            }}
          >
            Did you know? SportsHeadz integrates directly with your sports team,
            making it easy to set up fundraisers and share them with your
            members across multiple platforms.
          </AppText>
          <AppFlexbox>
            <Anchor
              href="https://sportsheadz.com"
              style={{
                fontSize: 14,
                color: 'dodgerblue',
                fontStyle: 'italic',
                textAlign: 'center'
              }}
              target="_blank"
            >
              Learn more about SportsHeadz teams
            </Anchor>
          </AppFlexbox>
        </AppStack>
      )}
    </AppStack>
  );
};

StoreCreationStoreTypeStep.propTypes = {
  createOptions: PropTypes.object,
  formState: PropTypes.object,
  loading: PropTypes.bool,
  setFormState: PropTypes.func
};

export default StoreCreationStoreTypeStep;
